import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To332(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMediaObjectRatio1To332"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 8.5v15a1.5 1.5 0 0 1-3 0v-15a1.5 1.5 0 1 1 3 0m-5 0a3.5 3.5 0 1 1 7 0v15a3.5 3.5 0 1 1-7 0zM13.032 8a1 1 0 0 1 1-1h13.936a1 1 0 1 1 0 2H14.032a1 1 0 0 1-1-1m0 8a1 1 0 0 1 1-1h13.936a1 1 0 1 1 0 2H14.032a1 1 0 0 1-1-1m1-5a1 1 0 1 0 0 2h8.774a1 1 0 1 0 0-2zm-1 9a1 1 0 0 1 1-1h8.774a1 1 0 1 1 0 2h-8.774a1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To332);
